import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import CustomSlider from './CustomSlider';
import verified from '../assets/images/verified.svg';
import PostMeta from './PostMeta';
import drop_horz from '../assets/images/drop_horz.svg';
import heart_icon from '../assets/images/heart_icon.svg';
import heart_icon_fill from '../assets/images/heart_icon_fill.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import comment_icon from '../assets/images/comment_icon.svg';
import bookmark_icon from '../assets/images/bookmark_icon.svg';
import bookmark_icon_fill from '../assets/images/bookmark_icon_fill.svg';
import empty_blue from '../assets/images/empty-feed.svg';
import loaderIcon from '../assets/images/loader.gif';
import config from '../config/config';
import PostDropdown from './PostDropdown';
import SubscribeButton from './SubscribeButton';
import UserMention from './UserMention';

const UsersProfileOnlyPostsCompact = ({ userId, onPostCountChange, filter, isCompactView }) => {
  const [posts, setPosts] = useState([]);
  const [currentUserDetails, setCurrentUserDetails] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [mediaCount, setMediaCount] = useState({});
  const [activeTab, setActiveTab] = useState('all'); 

// Function to fetch posts
const fetchPosts = async (pageNum = 1) => {
  const token = localStorage.getItem('token');

  // Check if userId is valid
  if (!userId) {
    console.error('User ID is missing');
    return;
  }

  setLoading(true);
  try {
    // Log the userId for debugging
    console.log('Fetching posts for userId:', userId);

    // Fetch posts for the authenticated user using type=image
    const url = `${config.baseURL}/get-user-posts?user_id=${userId}&type=media&page=${pageNum}`;

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Log the API response for debugging
    console.log('Posts API response:', response.data);

    const { 
      posts: fetchedPosts = [], 
      total_posts, 
      total_media_posts, 
      total_image_posts, 
      total_video_posts, 
      total_posts_likes 
    } = response.data;

    // Filter fetched posts to only include those by the specified user ID
    const newPosts = fetchedPosts.filter(post => post.user_id === userId);

    // Merge new posts with existing posts, avoiding duplicates
    setPosts((prevPosts) => {
      const existingPostIds = new Set(prevPosts.map((post) => post.id));
      const uniqueNewPosts = newPosts.filter((post) => !existingPostIds.has(post.id));

      // Process posts without the isAuthUserPost field
      return [...prevPosts, ...uniqueNewPosts];
    });

    // Update hasMore state based on whether there are more posts to fetch
    setHasMore(newPosts.length > 0);

    // Notify parent component about the total posts and media posts
    if (onPostCountChange) {
      onPostCountChange(total_posts, total_media_posts, total_image_posts, total_video_posts, total_posts_likes);
    }

    // Fetch current user details
    const userDetailsResponse = await axios.get(`${config.baseURL}/current-user-details`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const userDetails = userDetailsResponse.data.data;
    setCurrentUserDetails(userDetails);

    // Log current user details for debugging
    console.log('User details:', userDetails);

    // Update media count based on fetched posts (if needed in your app)
    updateMediaCount(fetchedPosts);

  } catch (error) {
    console.error('Error fetching posts:', error);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (userId) {
    fetchPosts(); // Call fetchPosts once userId is available
  }
}, [userId]);  

const updateMediaCount = (posts) => {
  posts.forEach(post => {
    // Check if the post is of type 'paid' and belongs to the desired user
    if (post.type === 'paid' && post.user_id === userId) {
      const userPosts = post.user_posts || [];
      const images = userPosts.filter(media => media.media_type === 'image').length;
      const videos = userPosts.filter(media => media.media_type === 'video').length;

      // Update the media count for this post
      setMediaCount(prevMediaCount => ({
        ...prevMediaCount,
        [post.id]: { images, videos }
      }));
    }
  });
};



  const handleScroll = () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const bottomPosition = document.documentElement.scrollHeight;

    if (scrollPosition >= bottomPosition - 100 && !loading && hasMore) {
      setPage(prevPage => {
        const nextPage = prevPage + 1;
        fetchPosts(nextPage);
        return nextPage;
      });
    }
  };

  useEffect(() => {
    fetchPosts();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [filter]);

  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  const getContentWithLinks = (content = '', mentions = []) => {
    if (!Array.isArray(mentions)) {
      console.error('Invalid mentions parameter, expected an array.');
      return content;
    }
    if (!mentions.length) return content;
    let updatedContent = content;
    mentions.forEach(mention => {
      if (mention.user && mention.user.user_name) {
        const mentionText = `@${mention.user.user_name}`;
        const mentionLink = `/${mention.user.user_name}`;
        const regex = new RegExp(`(${mentionText})(?![^<]*>)`, 'g');
        updatedContent = updatedContent.replace(regex, `<a href="${mentionLink}">${mentionText}</a>`);
      } else {
        console.warn('Invalid mention object:', mention);
      }
    });

    return updatedContent;
  };

  const mediaPosts = posts.filter(post => post.media && post.media.length > 0);


  useEffect(() => {
    fetchFilteredPosts(filter);
  }, [filter]);

  const fetchFilteredPosts = async (filter) => {
    const token = localStorage.getItem('token');
    try {
      let url = `${config.baseURL}/get-auth-user-posts`;
      if (filter === 'mostLiked') {
        url = `${config.baseURL}/get-user-liked-posts?user_id=${userId}`;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setPosts(response.data.posts || []);
    } catch (error) {
      console.error('Error fetching filtered posts:', error);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab); // Update the active tab
  };

  return (

    <div className="home_post_content user_post_content_by_user">
      {posts.length === 0 && !loading && !hasMore ? (
        <div className="post_content_block">                              
          <div className="no_feed">
            <img src={empty_blue} alt="" />
            <p className="no_list">No posts yet</p>
          </div>
        </div>
      ) : (
        <>        
            <div className="CompactViewBlock">
  {mediaPosts
    .filter(post => post.user_id === userId) // Filter posts by userId
    .map(post => (
      <div className="unlock_blog_post removed_locked" key={post.id}>
        <div className="without_locked">
          {post.media && post.media.length > 0 ? (
            post.media.map(mediaItem => (
              mediaItem.file_type === 'video' ? (
                <video key={mediaItem.id} controls className="media-video">
                  <source src={mediaItem.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : mediaItem.file_type === 'image' ? (
                <Link to={`/${post.id}/${post.user.user_name}`} key={mediaItem.id}>
                  <img
                    src={mediaItem.url}
                    alt={`Post media ${mediaItem.id}`}
                    className="media-image"
                  />
                </Link>
              ) : null
            ))
          ) : (
            <p>No media available</p>
          )}
        </div>
        <div className="unlock_subscribe_btn unlock_padding_margin_remove">
          <div className="media_wrap_paid">
            <div className="media_count_left">
              <div className="media_count">
                {post.total_images > 0 && (
                   <svg
                          width={54}
                          height={54}
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.3158 41.3006H41.1197C41.873 41.3006 42.2756 40.4134 41.7795 39.8464L34.4309 31.448C34.1088 31.0799 33.548 31.0465 33.1845 31.3736L25.6712 38.1356C25.3346 38.4385 24.8227 38.4353 24.4899 38.1281L20.0343 34.0153C19.6738 33.6824 19.1103 33.7103 18.7843 34.077L13.6605 39.8413C13.1578 40.4068 13.5593 41.3006 14.3158 41.3006Z"
                            fill="#8A96A3"
                          />
                          <circle
                            cx="3.94569"
                            cy="3.94569"
                            r="3.94569"
                            transform="matrix(-1 0 0 1 23.7617 15.873)"
                            fill="#8A96A3"
                          />
                          <path
                            d="M48.314 7.98131V47.4382C48.314 47.9225 47.9215 48.315 47.4372 48.315H7.98034C7.49608 48.315 7.10352 47.9225 7.10352 47.4382V7.98131C7.10352 7.49706 7.49608 7.10449 7.98034 7.10449H47.4372C47.9215 7.10449 48.314 7.49706 48.314 7.98131Z"
                            stroke="#8A96A3"
                            strokeWidth="4.82251"
                            strokeLinecap="round"
                          />
                        </svg>
                )}
                      {post.total_videos > 0 && (
                        <svg
                          width={54}
                          height={54}
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          >
                          <path
                            d="M36.8627 10.4512H5.8904C4.84636 10.4512 4 11.2975 4 12.3416V40.5492C4 42.7583 5.79086 44.5492 7.99999 44.5492H36.8627C39.0719 44.5492 40.8627 42.7583 40.8627 40.5492V14.4512C40.8627 12.242 39.0719 10.4512 36.8627 10.4512Z"
                            stroke="#8A96A3"
                            strokeWidth={5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M51.0005 15.52L40.8633 23.8141V30.7259L51.0005 39.9416V15.52Z"
                            stroke="#8A96A3"
                            strokeWidth={5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                      </svg>
                      )}
                <span>
                  {post.total_images > 0 && post.total_images}
                  {post.total_videos > 0 && post.total_videos}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
</div>

{loading && hasMore && (
  <div className="load_more text-center">
    <img className="loading_icon top_loader_space" src={loaderIcon} alt="Loading..." />
  </div>
)}

     
        </>
      )}
    </div>
  );
};

export default UsersProfileOnlyPostsCompact;